const HeaderTabLayout = [
    {
        "groupId": 1,
        "label": "Status",
        "fields": [
            {
                "name": "STATUS",
                "tableName": "",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,

            }
        ]
    }, {
        "groupId": 2,
        "label": "Receipts",
        "fields": [
            {
                "name": "SHOWSHIPPERONRECEIPT",
                "tableName": "",
                "label": "Show Shipper",
                "type": "select",
                "required": false,
                "visible": true,

            }
        ]
    }, {
        "groupId": 3,
        "label": "RF Used",
        "fields": [
            {
                "name": "RFTRANSACTION",
                "tableName": "",
                "label": "RF Used",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": true,

            }
        ]
    }, {
        "groupId": 4,
        "label": "Committed Transaction",
        "fields": [
            {
                "name": "MODIFYCOMMITTEDTRANS",
                "tableName": "",
                "label": "Allow Changes",
                "type": "select",
                "required": false,
                "visible": true,

            }
        ]
    }, {
        "groupId": 5,
        "label": "Allow Delete of Receipt",
        "fields": [
            {
                "name": "DELETERECEIPTS",
                "tableName": "",
                "label": "Receipts",
                "type": "select",
                "required": false,
                "visible": true,

            }
        ]
    }, {
        "groupId": 6,
        "label": "Choose Item Rate Sechedule",
        "fields": [
            {
                "name": "ACCESSRATESCHEDULE",
                "tableName": "",
                "label": "Rate Sechedule",
                "type": "select",
                "required": false,
                "visible": true,

            }
        ]
    }, {
        "groupId": 7,
        "label": "Trans/Recv Date Validation +/-",
        "fields": [
            {
                "name": "DATEVALIDATION",
                "tableName": "",
                "label": "Date Validation",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 8,
        "label": "Lookups",
        "fields": [
            {
                "name": "LIMITCONSIGNEELOOKUP",
                "tableName": "",
                "label": "Consignee",
                "type": "select",
                "required": false,
                "visible": true,

            }
        ]
    }
    , {
        "groupId": 9,
        "label": "Transaction Defaults",
        "fields": [
            {
                "name": "TRANSNOGENERATION_RECEIPT",
                "tableName": "",
                "label": "Receipts",
                "type": "select",
                "required": false,
                "visible": true,

            },
            {
                "name": "TRANSNOGENERATION_SHIPMENT",
                "tableName": "",
                "label": "Shipments",
                "type": "select",
                "required": false,
                "visible": true,

            }
            ,
            {
                "name": "TRANSNOGENERATION_ADJUSTMENT",
                "tableName": "",
                "label": "Adjustments",
                "type": "select",
                "required": false,
                "visible": true,

            },
            {
                "name": "TRANSACTIONPREFIX",
                "tableName": "WMTRANSACTIONDP",
                "label": "Prefix",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "POPULATEACTUALRSDATE",
                "tableName": "",
                "label": "Recv/Ship Dt",
                "type": "select",
                "required": false,
                "visible": true,

            }
        ]
    }, {
        "groupId": 10,
        "label": "Transfer to FM",
        "fields": [
            {
                "name": "CREATEFMCONTENTS",
                "tableName": "",
                "label": "FM Content",
                "type": "select",
                "required": false,
                "visible": true,

            },
            {
                "name": "FMPICKUPDATE",
                "tableName": "",
                "label": "Pickup Date",
                "type": "select",
                "required": false,
                "visible": true,

            },
            {
                "name": "FROMSTAGE_FMTRANSFER",
                "tableName": "",
                "label": "From Stage",
                "type": "select",
                "required": false,
                "visible": true,

            },
            {
                "name": "FMTRANSACTIONNUMBER",
                "tableName": "",
                "label": "FM Tracking #",
                "type": "select",
                "required": false,
                "visible": true,

            },
            {
                "name": "TRANSFERTOCOMPANYID",
                "tableName": "",
                "label": "To Company Id",
                "type": "select",
                "required": false,
                "visible": true,

            }
        ]
    }, {
        "groupId": 11,
        "label": "Validation",
        "fields": [
            {
                "name": "VALIDATEINVOICESETUP",
                "tableName": "",
                "label": "Invoice Setup",
                "type": "select",
                "required": false,
                "visible": true,

            } ,
            {
                "name": "ALLOWUSERVALIDATION",
                "tableName": "",
                "label": "Execute Proc",
                "type": "select",
                "required": false,
                "visible": true,

            } ,
            {
                "name": "POPUPMESSAGEUSER",
                "tableName": "",
                "label": "User Msg",
                "type": "select",
                "required": false,
                "visible": true,

            } ,
            {
                "name": "ISPLACEHOLDERRECORD",
                "tableName": "",
                "label": "Placeholder",
                "type": "select",
                "required": false,
                "visible": true,

            } ,
            {
                "name": "LOTEXPIRATIONDATECHECK",
                "tableName": "",
                "label": "Lot Expiration Date Check",
                "type": "select",
                "required": false,
                "visible": true,

            } 
        ]
    }, {
        "groupId": 12,
        "label": "Allow Duplicate Codes",
        "fields": [
            {
                "name": "ALLOWDUPLICATEPO",
                "tableName": "",
                "label": "PO Reference#",
                "type": "select",
                "required": false,
                "visible": true,

            }  ,
            {
                "name": "DUPLICATETRAILERCARRIER",
                "tableName": "",
                "label": "Carrier Trailer",
                "type": "select",
                "required": false,
                "visible": true,

            } ,
            {
                "name": "DUPLICATESHIPPERBOLNUMBER",
                "tableName": "",
                "label": "Shipper #",
                "type": "select",
                "required": false,
                "visible": true,

            }  
        ]
    }, {
        "groupId": 13,
        "label": "Actual Recv/Ship Date Validation",
        "fields": [
            {
                "name": "VALIDATEACTRECSHIPDT",
                "tableName": "",
                "label": "Validate",
                "type": "select",
                "required": false,
                "visible": true,

            }  ,
            {
                "name": "ACTRECSHIPDTDAYSBEHIND",
                "tableName": "",
                "label": "Days Behind",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            } ,
            {
                "name": "ACTRECSHIPDTDAYSAHEAD",
                "tableName": "",
                "label": "Days Ahead",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }  
        ]
    }, {
        "groupId": 14,
        "label": "Split Receipt",
        "fields": [
            {
                "name": "SPLITORDER",
                "tableName": "",
                "label": "Split Receipt",
                "type": "select",
                "required": false,
                "visible": true,

            }   ,
            {
                "name": "SPLITORDERSOURCEFIELD",
                "tableName": "",
                "label": "Split Order Source",
                "type": "select",
                "required": false,
                "visible": true,

            }   
        ]
    }, {
        "groupId": 15,
        "label": "Plan/Appt and Staging Dates",
        "fields": [
            {
                "name": "PLANDATETIMEDEFAULT",
                "tableName": "",
                "label": "Plan/Appt Dates",
                "type": "select",
                "required": false,
                "visible": true,

            }   ,
            {
                "name": "STAGINGDATETIMEDEFAULT",
                "tableName": "",
                "label": "Staging Dates",
                "type": "select",
                "required": false,
                "visible": true,

            }   
        ]
    }, {
        "groupId": 16,
        "label": "Cradit Validations",
        "fields": [
            {
                "name": "CREDITCHECKONSTAGECHANGE",
                "tableName": "",
                "label": "On Stage",
                "type": "select",
                "required": false,
                "visible": true,

            }    
        ]
    }, {
        "groupId": 17,
        "label": "User Validation - Commit",
        "fields": [
            {
                "name": "USERVALIDATIONONCOMMIT",
                "tableName": "",
                "label": "User Validation",
                "type": "select",
                "required": false,
                "visible": true,

            }    
        ]
    }
];

export {
    HeaderTabLayout,
}
